import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

export interface Props {
  className?: string;
  title: string;
  score: number;
}

class YourScore extends React.Component<Props, any> {
  public render() {
    const { className, score, title } = this.props;

    return (
      <div className={className}>
        <span className="title">{title}</span>
        <span className="score">{score}</span>
      </div>
    );
  }
}

export default styled(YourScore)`
  display: flex;
  padding: 0.75em 1em;

  .title {
    margin-right: 6px;
  }

  .score {
    font-size: 2em;
    line-height: 0.9em;
  }
`;
